export default function ToastSuccessIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
      <path
        d="M18.0352 10C18.0352 5.77502 14.6097 2.34961 10.3848 2.34961C6.15979 2.34961 2.73438 5.77502 2.73438 10C2.73438 14.225 6.15979 17.6504 10.3848 17.6504V19C5.4142 19 1.38477 14.9706 1.38477 10C1.38477 5.02944 5.4142 1 10.3848 1C15.3553 1 19.3848 5.02944 19.3848 10C19.3848 14.9706 15.3553 19 10.3848 19V17.6504C14.6097 17.6504 18.0352 14.225 18.0352 10Z"
        fill="white"
      />
      <path
        d="M6.19542 10.8126C5.93182 10.549 5.93182 10.1219 6.19542 9.85829C6.45902 9.59469 6.88613 9.59469 7.14974 9.85829L9.50101 12.2096L13.62 8.09052C13.8836 7.82692 14.3108 7.82692 14.5744 8.09052C14.838 8.35413 14.838 8.78124 14.5744 9.04484L9.97817 13.641C9.71456 13.9046 9.28745 13.9046 9.02385 13.641L6.19542 10.8126Z"
        fill="white"
      />
    </svg>
  )
}
